import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=77d8f1de&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8f1de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/workspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
installComponents(component, {VBtn,VCard})
